export class JwtUser {
  sessionId: string;
  winUserID: string;
  token: string;
  domain: string;
  ipaddress: string;
  uuid: string;
}
